import {ApplicationStateRepository} from '@/profile-creation-wizard/components/for-completion/domain/application-state/ApplicationStateRepository';
import {context} from 'vue3-starter/src/typescript/app-context/AppContext';
import {ApplicationStateRequest} from '@/common/api/api-raw-types';
import {ApplicationStatus} from '@/profile-creation-wizard/types';
import {ApplicationStateActions} from '../../domain/application-state/ApplicationState';
export class ApplicationStateRepositoryAPI implements ApplicationStateRepository {
    sumbitApplication(): Promise<void> {
        throw new Error('Method not implemented.');
    }
    async getApplicationState(): Promise<ApplicationStatus> {
        const [data, error] = await context.httpService.get(context.registry.entries.getApplicationState());
        if (error) {
            throw new Error(error.message);
        }

        return data as ApplicationStatus;
    }

    async updateApplicationState(state: ApplicationStateActions): Promise<void> {
        const [data, error] = await context.httpService.put(context.registry.entries.updateApplicationState(), {
            state: state,
        } as ApplicationStateRequest);
    }
}
